// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"83d7976c","404":"18fdde12","496":"d3145bb9","498":"fc88bc2e"}[chunkId] + ".chunk.js";
};